import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { initKeycloak } from "./keycloak";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
// detect external routes (using HashRouter)
const isExternal = window.location.hash.startsWith("#/externals");

if (isExternal) {
  // Render immediately, skip Keycloak
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Normal Keycloak bootstrapping for protected parts
  initKeycloak()
    .then(async (kc) => {
      localStorage.setItem("kc_token", kc.token!);
      localStorage.setItem("kc_refreshToken", kc.refreshToken!);

      kc.onTokenExpired = () => {
        kc.updateToken(30)
          .success((refreshed) => {
            if (refreshed) {
              localStorage.setItem("kc_token", kc.token!);
              localStorage.setItem("kc_refreshToken", kc.refreshToken!);
            }
          })
          .error(() => console.error("Token refresh failed"));
      };

      try {
        const resp = await fetch(`${API_URL}/users/me`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${kc.token!}`,
          },
        });
        if (!resp.ok) throw new Error(`Profile fetch failed (${resp.status})`);
        const me = await resp.json();
        localStorage.setItem("me", JSON.stringify(me));
      } catch (err) {
        console.error("Could not load /users/me", err);
      }

      root.render(
        <React.StrictMode>
          <title>Hubency - Carebag</title>
          <App />
        </React.StrictMode>
      );
    })
    .catch((err) => {
      console.error("Keycloak init failed", err);
    });
}

reportWebVitals();
